import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportResultCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetInternalAuditReportResultCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetInternalAuditReportResultCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  // Map each per-table count back onto its GraphQL aggregate root. ConnectedCount
  // sums the four; a null count (that group's query failed) becomes a null
  // aggregate so the badge blanks rather than reading as 0.
  mapTrpcDataToGraphQL: (data) => ({
    risk_controlled_internal_audit_result_aggregate: {
      aggregate: toAggregate(
        data.internalAuditReportResult.risk_controlled_internal_audit_result
      ),
    },
    risk_uncontrolled_internal_audit_result_aggregate: {
      aggregate: toAggregate(
        data.internalAuditReportResult.risk_uncontrolled_internal_audit_result
      ),
    },
    document_internal_audit_result_aggregate: {
      aggregate: toAggregate(
        data.internalAuditReportResult.document_internal_audit_result
      ),
    },
    obligation_internal_audit_result_aggregate: {
      aggregate: toAggregate(
        data.internalAuditReportResult.obligation_internal_audit_result
      ),
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetInternalAuditReportResultCountDocument,
});
